'use strict';
const _ = require('lodash');
const $ = require('jquery');
const Backbone = require('backbone');
const PubSub = require('../PubSub');
const template = require('../templates/progress.ejs');
const getScrollY = require('../util/scroll-position');

module.exports = Backbone.View.extend({
    className: 'view-progress',
    _domRefs: {},
    _headerHeight: 0,
    _windowHeight: 0,
    _elsCached: false,
    _handleScrollRef: null,
    events: {
        'click .btn-submit': 'submitVotes'
    },
    /**
     *
     */
    initialize: function (options) {
        _.bindAll(this, 'render');
        options = options || {};

        this.auth = this.model.get('auth');
        this.categories = this.model.get('categories');
        this.window = this.model.get('window');
        this.cms = options.cms;

        var isPrenomPhase = _.checkIfTrue(this.model.get('copy')['submit_button']['display']);
        this.isSubmitDisabled = true;

        this.listenTo(this.window, 'change:appState', this.render.bind(this));
        this.listenTo(this.categories, 'change', this.render.bind(this));
        this.listenTo(this.auth, 'change:voteData', this.render.bind(this));
        this.listenTo(this.model, 'change:copy', this.render.bind(this));
        this.listenTo(PubSub, 'window:scroll', this.handleScroll.bind( this ));
        this.listenTo(PubSub, 'window:resize', this.handleResize.bind( this ));
        this.listenTo(PubSub, 'vote-allocation-change', this.handleAllocationChange.bind( this ));

        if(isPrenomPhase){
            this.listenTo(PubSub, 'voteSuccess', this.handleVoteSuccessOnPrenomPhase.bind(this));
            this.listenTo(PubSub, 'logout', this.handleLogoutOnPrenomPhase.bind(this));
            this.listenTo(this.categories.models[0], 'change:isSubmitted', this.handleSubmitted.bind(this));
        }
    },
    /**
     *
     */
    render: function () {
        var voteLimit = this.cms.turboVote.get('voteLimit');
        var votesRemaining = voteLimit - this.categories.models[0].get('totalAllocatedVotes');

        var appState = this.window.get('appState');
        var displayProgress = parseInt(this.model.get('copy').display);

        if(appState !== 'open' || !displayProgress) {
            this.$el.html('');
            document.body.classList.add('no-progress');
            return this;
        }

        var totalActiveCategories = this.categories.getTotalActiveCategories();
        var totalSubmittedCategories = this.categories.getTotalSubmittedCategories();

        var model = {
            text: this.model.get('copy').text.replace('{{CATEGORIES}}', totalActiveCategories),
            votes: totalSubmittedCategories,
            isSubmitDisplayed: _.checkIfTrue(this.model.get('copy')['submit_button']['display']),
            isSubmitDisabled: this.isSubmitDisabled || this.categories.models[0].get('isSubmitted'),
            submitCopy: this.model.get('copy')['submit_button']['copy'],
            voteLimit: voteLimit,
            votesRemaining: votesRemaining
        };
        this.$el.html(template(model));

        this.cacheDomRefs();
        this.handleResize();

        document.body.classList.remove('no-progress');
        return this;
    },
    handleAllocationChange: function(isDisabled){
        var isSubmitted = this.categories.models[0].get('isSubmitted');
        this.isSubmitDisabled = isDisabled || isSubmitted;
        this.render();
    },
    /**
     *
     */
    renderedToDom: function() {
        this.handleScroll();
    },
    /**
     * cacheDomRefs
     */
    cacheDomRefs: function() {

        if ( this._elsCached ) return;

        this._domRefs = ['vote-progress', 'view-progress'].reduce( function( memo, className ) {

            memo[ className ] = $( '.' + className );

            return memo;

        }, { 'mtv-header': $('#header') });

        this._elsCached = true;

    },
    /**
     * checkIfProgressBarShouldBeSticky
     * checks if the fixed position progress bar is below its container in y position
     */
    checkIfProgressShouldBeSticky: function( scrollPos ) {

        this.cacheDomRefs();

        var containerPosition = this._domRefs['vote-progress'].position();
        var containerHeight = this._domRefs['view-progress'].outerHeight();

        if ( containerPosition ) {

            var containerYPos = containerPosition.top;

            return scrollPos <= containerYPos + containerHeight  - this._windowHeight;

        }

        return false;

    },
    /**
     * handleScroll
     * @param {integer} scrollPos - optional scrollY position
     */
    handleScroll: function( scrollPos ){

        if(!this.categories.getTotalActiveCategories()) return;

        scrollPos = scrollPos || getScrollY();

        var makeSticky = this.checkIfProgressShouldBeSticky( scrollPos );
        var $progressEl = this._domRefs['view-progress'];
        var showProgress = this._headerHeight < scrollPos;

        this.$el.parent().toggleClass( 'progress-show', showProgress );
        $progressEl && $progressEl.toggleClass( 'progress-fixed', makeSticky );


    },
    submitVotes: function(){
        var cat = this.model.get("categories").models[0];
        var data = {
            categoryID: cat.get("id"),
            categoryName: cat.get('name'),
            categoryVoteData: cat.get("categoryVotes"),
            totalAllocatedVotes: cat.get("totalAllocatedVotes"),
        };
        PubSub.trigger("submitVotes", data);
    },
    /**
     *
     */
    handleResize: function() {
        this._headerHeight = this._domRefs['mtv-header'] ? this._domRefs['mtv-header'].outerHeight(): 0;
        this._windowHeight = window.innerHeight || document.documentElement.clientHeight;
    },
    /**
     * https://telescopetv.atlassian.net/browse/MV-1146
     * client requested to hide the fixed footer when a user submitted a vote.. ONLY on PRENOM phase
     */
    handleVoteSuccessOnPrenomPhase: function(){
        this.$el.hide();
    },
    /**
     * https://telescopetv.atlassian.net/browse/MV-1146
     * new requirements from client requires us to hide this view after the user submits a vote.
     * we now need to show the view again if the user logs out bc if we dont and another user logs in w/o
     * refreshing the browser, the view will stay hidden
     */
    handleLogoutOnPrenomPhase: function(){
        this.$el.show();
    },
    /**
     * this function is needed to hide this view once the user has logged in and the app has determined that the user has voted already
     */
    handleSubmitted: function(hasUserVotedAlredy){
        if(hasUserVotedAlredy){
            this.handleVoteSuccessOnPrenomPhase();
        }
    },
    /**
     * remove
     */
    remove: function() {
        clearTimeout( this._handleScrollRef );
        this.stopListening();
        return Backbone.View.prototype.remove.call( this );
    }
});



// WEBPACK FOOTER //
// ./app/scripts/views/progress.js